import { AppLayout } from '../components/AppLayout';
import { UserRoute } from '../components/ProtectedRoute';

// Access control is handled inside ttadmin.tsx (email check for ryand32@gmail.com)
// Using UserRoute here so the page loads, then the component gates on email
export default [UserRoute, AppLayout];
